import { Expose } from 'class-transformer'

export class BookCategoryType {
  @Expose() id: number

  @Expose() name: string
}
